import { render, staticRenderFns } from "./TemplateSummaries.vue?vue&type=template&id=511ef24a&scoped=true"
import script from "./TemplateSummaries.vue?vue&type=script&lang=js"
export * from "./TemplateSummaries.vue?vue&type=script&lang=js"
import style0 from "./TemplateSummaries.vue?vue&type=style&index=0&id=511ef24a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511ef24a",
  null
  
)

export default component.exports